// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './App'
import store from './store'

// 视频直播
import VueVideoPlayer from 'vue-video-player'

// 引入样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
// 引入全局样式
import '@/assets/css/global.less'

// 使用组件
Vue.use(VueVideoPlayer)

// ui组件
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


// 省市区选择
import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker)

Vue.use(ElementUI);

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   ak: 'tBbqswxlv2qT1dUsr3guol7m5hLV4aPi' // 百度地图秘钥
// })

/* 路由 */
import router from './router'

/* axios */
import requests from './api'
import api from './api/api'
Vue.prototype.http = requests;
Vue.prototype.api = api;

/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)

/* 尾部组件 */
import Footer from './components/FooterNew'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)

// 文件上传
import FileUpload from "./components/upload/FileUpload";
Vue.component(FileUpload.name, FileUpload);

// 轮播图组件
import carouselImage from "@/components/carouselImageNew";
Vue.component("carousel-image", carouselImage);

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title+'_世策软件'
    }
    next();
});

// 从下往上淡入
Vue.directive('animate-on-scroll', {
  inserted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animation_fadeInUp');
        }
      });
    });
    observer.observe(el);
  }
});
// 从上往下淡入
Vue.directive('animate-on-scrollD', {
  inserted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animation_fadeInDown');
        }
      });
    });
    observer.observe(el);
  }
});
// 从z轴方向进入
Vue.directive('animate-on-scroll1', {
  inserted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animation_zoomIn');
        }
      });
    });
    observer.observe(el);
  }
});

// 弹跳从左进入
Vue.directive('animate-on-scrollL', {
  inserted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animation_bounceL');
        }
      });
    });
    observer.observe(el);
  }
});
// 弹跳从右进入
Vue.directive('animate-on-scrollR', {
  inserted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animation_bounceR');
        }
      });
    });
    observer.observe(el);
  }
});


new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js